export const HighIndexConsentData  = {
  title: 'High Index Consent Form',
  description: `I consent to the use of high-index 1.67 lenses in my child’s
  glasses instead of the recommended polycarbonate lenses. I confirm that
  I have been advised of the risks associated with high-index 1.67
  lenses and that polycarbonate would not have those associated risks.
  `,
  checkBoxLabel: 'I Understand and Agree',
};
  